import "./Banner.scss";
import BannerImg from "../../../assets/banner-img.png"

const Banner = () => {
    return <div className="hero-banner">
        <div className="content">
            <div className="text-content">
                <h1>SALE!</h1>
                <p>Upto 40% off on best brands. Don't miss out! </p>
                <div className="ctas">
                    <div className="banner-cta">Know More</div>
                    <div className="banner-cta v2">Shop Now</div>
                </div>
            </div>
            <img className="banner-img" src={BannerImg} alt=""/>
        </div>
    </div>;
};

export default Banner;
